import React from "react";
import { Container, ComponentLabel } from "./DocumentEditor.styled";
import { DocumentHeader, DocumentToolbar, DocumentContent, DocumentActions } from "./components";

const DocumentEditor = () => {
  return (
    <Container>
      <ComponentLabel>DocumentHeader</ComponentLabel>
      <DocumentHeader />

      <ComponentLabel>DocumentToolbar</ComponentLabel>
      <DocumentToolbar />

      <ComponentLabel>DocumentContent</ComponentLabel>
      <DocumentContent />

      <ComponentLabel>DocumentActions</ComponentLabel>
      <DocumentActions />
    </Container>
  );
};

export default DocumentEditor;
